<script lang="ts" setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import MascotIcon from "~/assets/icons/broadcast-mascot.svg";
import { Channel } from "~/entities/channel";
import { useBroadcast } from "~/stores/broadcast.store";
import { useChannels } from "~/stores/channel.store";

const router = useRouter();
const broadcastStore = useBroadcast();
const channelStore = useChannels();
const selectChannelOpened = ref<boolean>(false);
function onCreateBroadcastClick() {
  selectChannelOpened.value = true;
}
function onChannelSelected(c: Channel) {
  channelStore.setSelectedWabaChannel(c.id || null); // todo: возвращать boolean
  if (c.id) {
    router.push({ name: "broadcastSender" });
  }
}
</script>

<template>
  <div class="empty-statistics">
    <div class="empty-statistics__content">
      <MascotIcon />
      <div class="empty-statistics__text">
        <h4 v-if="broadcastStore.isSendingDisabled">Рассылок ещё нет</h4>
        <h4 v-else>Вы еще не создавали массовые рассылки</h4>
        <p v-if="broadcastStore.isSendingDisabled">
          Для того, чтобы создать рассылку,<br />
          нужен канал.
        </p>
        <p v-else>Создайте свою первую рассылку<br />уже сейчас.</p>
      </div>
      <PButton
        v-if="broadcastStore.isSendingDisabled"
        :variant="'default'"
        :size="'small'"
        :color="'primary'"
        :loading="false"
        :nuxt="false"
        :type="'button'"
        :block="true"
        :href="'https://sendbot.yourgood.ru/kak-podklyuchit-ofitsialnyy-whatsapp-dlya-sendbot'"
        :style="{ width: '268px', textAlign: 'center' }"
      >
        Подробнее о подключении канала
      </PButton>
      <PButton
        v-else
        :variant="'default'"
        :size="'small'"
        :color="'primary'"
        :loading="false"
        :nuxt="false"
        :type="'button'"
        :block="true"
        :disabled="broadcastStore.isSendingDisabled"
        @click="onCreateBroadcastClick"
        :style="{ width: '155px' }"
      >
        Создать рассылку
      </PButton>
    </div>
  </div>
  <ModalSelectChannel
    v-model:open="selectChannelOpened"
    :value="channelStore.selectedWabaChannelId"
    :options="channelStore.wabaChannels"
    @item-selected="onChannelSelected"
  />
</template>

<style scoped>
.empty-statistics {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-statistics__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 403px;
  gap: 24px;
}

.empty-statistics__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.empty-statistics__content h4 {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: var(--common-black);
}

.empty-statistics__content p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: var(--common-asphalt);
}
</style>
